import { createColumnHelper } from '@tanstack/react-table';

import { capitalize } from '@src/utils';
import CountryBadge from '@src/components/CountryBadge';
import WebinarActionCell from '../Components/WebinarActionCell';
import { IAttendee } from '@src/webinar/types';

import styles from './AttendeesTable.module.scss';

const columnHelper = createColumnHelper<IAttendee>();

export const ATTENDEES_COLUMNS = [
  columnHelper.accessor((row) => `${capitalize(row.firstName)}`, {
    id: 'name',
    size: 240,
    cell: (info) => <span className={styles.nameCell}>{info.getValue()}</span>,
    header: () => <span>Name</span>,
    footer: (info) => info.column.id,
  }),
  columnHelper.accessor('email', {
    id: 'email',
    size: 240,
    cell: (info) => <span>{info.getValue()}</span>,
    header: () => <span>Email</span>,
    footer: (info) => info.column.id,
  }),
  columnHelper.accessor('company', {
    header: () => <span>Company</span>,
    cell: (info) => <span>{capitalize(info.getValue() || '-')}</span>,
    footer: (info) => info.column.id,
  }),
  columnHelper.accessor('type', {
    header: () => <span>Type</span>,
    cell: (info) => <span>{capitalize(info.getValue().replace('_', '-'))}</span>,
    footer: (info) => info.column.id,
  }),
  {
    id: 'location',
    header: () => <span>Country and City</span>,
    size: 180,
    cell: (info: any) => {
      const value = info?.row?.original;
      if (!value) return null;
      if (!value.city && !value.countryCode) return '-';
      const code = value.countryCode ? value.countryCode.toLowerCase() : 'xx';

      return <CountryBadge countryCode={code} countryName={value.city} />;
    },
  },
  {
    id: 'action',
    size: 225,
    cell: (cellContext: any) => {
      const row = cellContext.row.original;
      return <WebinarActionCell attendee={row} />;
    },
  },
];
